





import Vue from 'vue';
import axios from 'axios';
import api from '../api';
import CosmetRegister from '../components/CosmetRegister.vue';
export default Vue.extend({
  name: 'cosmetregister',
  data() {
    return {};
  },
  components: {
    CosmetRegister
  }
});
